<template>
    <div class="middle-panel">
        <div class="middle-panel-header">
            <div class="middle-panel-header-title">
                <span>NOMINATION CATEGORIES</span>
            </div>
            <div class="middle-panel-header-option">
                <span @click="closeCategoriesMobile">Close</span>
            </div>
        </div>
        <div class="middle-panel-body">
            <div class="nomination-category-item" v-for="(category, index) in categories" :key="index" :class="{
                active: selected_category && selected_category.id == category.id,
            }">
                <div class="nomination-category-item-header">
                    <div class="nomination-category-title" @click="selectCategory(category)">
                        {{ category.prio }} - {{ category.name }}
                    </div>
                    <div class="nomination-category-count">
                        <b-tag type="is-info">{{ category.nominees_count }} nominees</b-tag>
                    </div>
                </div>
                <div class="nomination-category-item-footer" @click="selectCategory(category)">
                    <div class="nomination-category-item-footer-left">
                        <div class="nomination-category-item-winner-number">
                            Allowed winners: {{ category.winners_number }}
                        </div>
                    </div>
                    <div class="nomination-category-item-footer-right">
                        <b-tag v-if="category.status == 'public'" type="is-success">Public</b-tag>
                        <b-tag v-if="category.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        session: {
            type: Object,
            default: () => ({})
        },
        nominees: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        session_id() {
            return this.session.id;
        },
    },
    data: () => ({
        selected_category: null,
        categories: [],
        loading_categories: false,
    }),
    watch: {
        session_id: function (val) {
            this.getAllMyVotingCategories();
        },
    },
    mounted() {
        this.getAllMyVotingCategories();
    },
    methods: {
        closeCategoriesMobile() {
            this.$emit('close');
        },
        selectCategory(category) {
            this.selected_category = category;
            this.$emit("selected", category);
        },
        getAllMyVotingCategories() {
            if (!this.session_id) return;

            this.loading_categories = true;
            this.$store
                .dispatch("VOTING_GET_ALL_MY_VOTING_CATEGORIES", {
                    session_id: this.session_id,
                })
                .then((response) => {
                    this.loading_categories = false;
                    this.categories = response.data.return.sort((a, b) =>
                        a.prio > b.prio ? 1 : -1
                    );
                })
                .catch(({ response }) => {
                    this.loading_categories = false;
                    this.$buefy.toast.open({
                        message: "Failed to load categories",
                        type: "is-danger",
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.middle-panel {
    height: 100%;
    width: 400px;
    overflow-y: auto;
    border-left: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    @media (max-width: 592px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 60px;
        right: 0;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
    }

    @media (max-width: 470px) {
        width: 96%;
    }

    .middle-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;
        background: #fff;
        position: sticky;
        top: 0;

        .middle-panel-header-option {
            display: flex;
            align-items: center;

            span {
                display: none;
                margin-left: 10px;
                color: red;
                font-weight: 700;
                cursor: pointer;

                @media (max-width: 592px) {
                    display: flex;
                }
            }
        }
    }

    .middle-panel-body {
        height: calc(100% - 60px);
        overflow-y: auto;

        .nomination-category-item {
            width: 100%;
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid #ddd;
            cursor: pointer;

            &:hover {
                background: #fff;
            }

            &.active {
                background: #fff;
            }

            .nomination-category-item-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px;

                .nomination-category-title {
                    font-size: 14px;
                    font-weight: 600;
                    color: #333;
                    flex: 1;
                }

                .nomination-category-count {
                    margin-left: 10px;
                }
            }

            .nomination-category-item-footer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px;

                .nomination-category-item-footer-left {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .nomination-category-item-winner-number {
                        font-size: 12px;
                        color: #333;
                    }
                }

                .nomination-category-item-footer-right {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
}
</style>
